export const energyDynamicSmall = (
  <>
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0H40C48.8366 0 56 7.16344 56 16V40C56 48.8366 48.8366 56 40 56H16C7.16344 56 0 48.8366 0 40V16Z"
      fill="url(#paint0_linear_33778_68727)"
    />
    <path
      d="M12 28.5122C19.6348 29.3171 19.5021 19 22.4896 19C25.4772 19 27.4025 37 31.8174 37C36.2324 37 37.4938 28.5122 44 28.5122"
      stroke="url(#paint1_linear_33778_68727)"
      strokeWidth="3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_33778_68727"
        x1="25.266"
        y1="-4.53704"
        x2="63.3256"
        y2="45.5654"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9ECE2" />
        <stop offset="1" stopColor="#D9DFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_33778_68727"
        x1="28"
        y1="21.1219"
        x2="28"
        y2="41.1707"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB7835" />
        <stop offset="1" stopColor="#0040FA" />
      </linearGradient>
    </defs>
  </>
);

export const energyDynamicLarge = (
  <>
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z"
      fill="url(#paint0_linear_10341_78409)"
    />
    <path
      d="M12 40.8537C25.3609 42.1951 25.1286 25 30.3568 25C35.5851 25 38.9544 55 46.6805 55C54.4066 55 56.6141 40.8537 68 40.8537"
      stroke="url(#paint1_linear_10341_78409)"
      strokeWidth="4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10341_78409"
        x1="36.0943"
        y1="-6.48148"
        x2="90.4651"
        y2="65.0934"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9ECE2" />
        <stop offset="1" stopColor="#D9DFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10341_78409"
        x1="40"
        y1="28.5366"
        x2="40"
        y2="61.9512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB7835" />
        <stop offset="1" stopColor="#0040FA" />
      </linearGradient>
    </defs>
  </>
);

export const energyFixSmall = (
  <>
    <rect width="56" height="56" rx="16" fill="url(#paint0_linear_33778_48897)" />
    <path
      d="M12 28C27.7037 28 31.6385 28 44 28"
      stroke="url(#paint1_linear_33778_48897)"
      strokeWidth="4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_33778_48897"
        x1="25.266"
        y1="-4.53704"
        x2="63.3256"
        y2="45.5654"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9ECE2" />
        <stop offset="1" stopColor="#D9DFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_33778_48897"
        x1="19.1111"
        y1="20.1748"
        x2="43.02"
        y2="27.7723"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB7835" />
        <stop offset="1" stopColor="#0040FA" />
      </linearGradient>
    </defs>
  </>
);

export const energyFixLarge = (
  <>
    <rect width="80" height="80" rx="16" fill="url(#paint0_linear_10341_78410)" />
    <path
      d="M20 40C39.6296 40 44.5481 40 60 40"
      stroke="url(#paint1_linear_10341_78410)"
      strokeWidth="4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10341_78410"
        x1="36.0943"
        y1="-6.48148"
        x2="90.4651"
        y2="65.0934"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9ECE2" />
        <stop offset="1" stopColor="#D9DFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10341_78410"
        x1="28.8889"
        y1="32.1748"
        x2="57.3089"
        y2="43.4635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB7835" />
        <stop offset="1" stopColor="#0040FA" />
      </linearGradient>
    </defs>
  </>
);
